module.exports = __webpack_public_path__ + "static/img/refuse.4598dbb4.svg";